import { render, staticRenderFns } from "./EditBannerItem.vue?vue&type=template&id=76839c34"
import script from "./EditBannerItem.vue?vue&type=script&lang=ts"
export * from "./EditBannerItem.vue?vue&type=script&lang=ts"
import style0 from "./EditBannerItem.vue?vue&type=style&index=0&id=76839c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports